/* unplugin-vue-components disabled */import { render } from "./describe.vue?vue&type=template&id=b6a2c15c&scoped=true"
import script from "./describe.vue?vue&type=script&lang=js"
export * from "./describe.vue?vue&type=script&lang=js"

import "./describe.vue?vue&type=style&index=0&id=b6a2c15c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a2c15c"]])

export default __exports__